<template>
	<CloActivityBadge :badges="badges" :title="comName" reverse />
</template>

<script>
import axios from 'axios';
import CloActivityBadge from '@/layouts/CloActivityBadge/CloActivityBadge.vue';

export default ({
	name: 'MyActivityBadges',
	components: {
		CloActivityBadge,
	},
	props: {
		userId: {
			type: String,
			required: true,
		},
		speciesCode: {
			type: String,
			required: true
		},
		comName: {
			type: String,
			required: true
		},
		mediaUrl: {
			type: String,
			required: true
		},
		obsUrl: {
			type: String,
			required: true
		},
		ebirdApiKey: {
			type: String,
			required: true
		},
		mediaApiUrl: {
			type: String,
			required: true
		},
		baseUrl: {
			type: String,
			required: true
		},
	},
	data() {
		return {
			badges: [
				{
					label: this.$i18n.t('species.seen'),
					icon: 'badgeSeen',
					href: this.baseUrl + 'lifelist?spp=' + this.speciesCode + '&time=life',
					loading: true,
				},
				{
					label: this.$i18n.t('species.photo'),
					icon: 'badgePhotographed',
					href: this.mediaUrl + '/catalog?birdOnly=true&userId=' + this.userId + '&taxonCode=' + this.speciesCode + '&mediaType=photo',
					loading: true,
				},
				{
					label: this.$i18n.t('species.audio'),
					icon: 'badgeRecordedAudio',
					href: this.mediaUrl + '/catalog?birdOnly=true&userId=' + this.userId + '&taxonCode=' + this.speciesCode + '&mediaType=audio',
					loading: true,
				},
				{
					label: this.$i18n.t('species.year'),
					icon: 'badgeSeenYear',
					href: this.baseUrl + 'lifelist?spp=' + this.speciesCode + '&time=year',
					loading: true,
				}
			],
		};
	},
	mounted() {
		axios
			.get(this.mediaApiUrl, {
					params: {
						speciesCode: this.speciesCode,
						userId: this.userId
					},
				})
			.then((res) => {
				this.badges[1].loading = false;
				this.badges[2].loading = false;
				if (res.data.userCountsWithPhoto > 0) {
					this.badges[1].achieved = true;
					this.badges[1].text =  this.$i18n.t('species.youPhoto');
				} else {
					this.badges[1].text = this.$i18n.t('species.youNotPhoto');
				}
				if (res.data.userCountsWithAudio > 0) {
					this.badges[2].achieved = true;
					this.badges[2].text = this.$i18n.t('species.youAudio');
				} else {
					this.badges[2].text = this.$i18n.t('species.youNotAudio');
				}
				this.$forceUpdate();
			})
			.catch((err) => {
				console.log(err);
			});
		const username = btoa(this.userId.replace('USER', ''));
		axios
			.get(this.obsUrl + this.speciesCode, {
					params: {
						username: username,
					},
					headers: { 'X-eBirdApiToken': this.ebirdApiKey },
				})
			.then((res) => {
				this.badges[0].loading = false;
				this.badges[3].loading = false;
				if (res.data.userObsCount > 0) {
					this.badges[0].achieved = true;
					this.badges[0].text = this.$i18n.t('species.youSee');
				} else {
					this.badges[0].text = this.$i18n.t('species.youNotSee');
				}
				if (res.data.userYearObsCount > 0) {
					this.badges[3].achieved = true;
					this.badges[3].text = this.$i18n.t('species.youYear');
				} else {
					this.badges[3].text = this.$i18n.t('species.youNotYear');
				}
				this.$forceUpdate();
			})
			.catch((err) => {
				console.log(err);
			});
	},
});
</script>

<style lang="scss">
.ActivityBadge--reverse {
	.ActivityBadge-badge {
		color: subdueColor($color-primary-1, true);
	}
	.ActivityBadge-badge--achieved {
		color: $color-white;
		//color: $brand-color-chartreuse-shade;
	}	
	.ActivityBadge-modal {
		.ActivityBadge-badge {
			color: $color-text-muted;
		}
		.ActivityBadge-badge--achieved {
			color: $color-link;
		}
	}
}
</style>
